module.exports = __webpack_public_path__ + "img/四川天府新区湖畔路中学.3be34163.jpg";